/**
 * Prüft ob die eingegebenen Passwörter die selben sind
 */
SP.lang.Class.define("SP.sitekit.form.validator.PasswordRepetition", {

	_options: null,

	_passwordFields : [],

	init: function (options) {
		this._options = options;
		if (this._options.fields && this._options.fields.length === 2) {
			for (var index in this._options.fields) {
				var pwField = document.querySelector(this._options.fields[index]);
				if (pwField) {
					this._passwordFields[index] = pwField;
				} else {
					console.error("could\'t find password fiel with id: ", this._options.fields[index]);
				}
			}
		} else {
			console.error("missing password fields");
		}
	},

	isValid: function (value) {
		if (this._passwordFields.length === 2 && this._passwordFields[0].value.length > 0 && this._passwordFields[1].value.length > 0) {
			if (this._passwordFields[0].value && this._passwordFields[1].value && this._passwordFields[0].value === this._passwordFields[1].value) {
				return true;
			}
		}
		return false;
	},

	getMessage: function () {
		return this._options.messages.passwordMissmatch;
	}

});